var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 5.71471L10.4018 4.98642L8 0L5.59766 4.98642L0 5.71471L4.11552 9.4449L3.05357 14.8571L8 12.1996L12.9475 14.8571L11.8839 9.4449L16 5.71471Z","fill":"#1A263E"}));
}

Star.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none"};

module.exports = Star;

Star.default = Star;
